// Photos lower down the page wait until they are nearly on screen before downloading, and iPhones wait longer than
// other phones, so product photos appeared one by one while scrolling and swiping. Once the page has loaded, this
// starts the next photos a little ahead of time, without fetching whole rows nobody looks at.
(function () {
  if (!('IntersectionObserver' in window)) return;

  var ROWS = '.swipe-mobile, .swiper';

  // Photos hidden on this screen size (for example the second photo shown on laptop hover) are left alone.
  function start(img) {
    if (img.loading === 'lazy' && img.getClientRects().length) img.loading = 'eager';
  }

  // Photos off to the side of a row that swipes sideways never count as near. As soon as a finger touches the row,
  // start the photos up to `screens` row-widths past its right edge, so the next cards are ready as they slide in.
  function startAhead(row, screens) {
    var limit = row.getBoundingClientRect().right + row.clientWidth * screens;
    row.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      var box = img.getBoundingClientRect();
      if (box.width && box.left < limit) start(img);
    });
  }

  // Photos down the page start once they are within about one and a half screens.
  var nearby = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      start(entry.target);
      nearby.unobserve(entry.target);
    });
  }, { rootMargin: '150% 0px' });

  function watchRow(row) {
    if (row.dataset.lazyEarly !== undefined) return;
    row.dataset.lazyEarly = '';
    var queued = false;
    function onSwipe() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; startAhead(row, 2); });
    }
    ['scroll', 'touchstart', 'pointerdown'].forEach(function (type) {
      row.addEventListener(type, onSwipe, { passive: true });
    });
  }

  function watch(root) {
    if (!root.querySelectorAll) return;
    if (root.matches('img[loading="lazy"]')) nearby.observe(root);
    if (root.matches(ROWS)) watchRow(root);
    root.querySelectorAll('img[loading="lazy"]').forEach(function (img) { nearby.observe(img); });
    root.querySelectorAll(ROWS).forEach(watchRow);
  }

  function init() {
    watch(document.body);
    // Products added later (filters, "load more") get the same treatment.
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) watch(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  // Waiting for the page to finish loading keeps these photos from slowing down what shows first.
  if (document.readyState === 'complete') init();
  else window.addEventListener('load', init);
})();
